import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { Miembro } from "../../../../../utils/types/groups/miembro.type";
import { RecordAction } from "../../../../../utils/enums/shared/enums";
import { MiembrosService } from "../../../../../services/groups/miembros.service";
import { AuthenticationService } from "../../../../../services/security/authentication.service";
import { TranslateService } from "@ngx-translate/core";
import { ValidationService } from "../../../../../services/validation/validation.service";

@Component({
    selector: "wtf-miembro-form",
    templateUrl: "./miembro-form.component.html",
    styleUrls: ["./miembro-form.component.scss"],
    providers: [MiembrosService, AuthenticationService, ValidationService],
    encapsulation: ViewEncapsulation.None,
})
export class MiembroFormComponent implements OnInit {
    miembroModel: Miembro;
    dialogTitle: string;
    miembroForm: FormGroup;
    action: RecordAction;

    callback: (miembro) => void;

    operators: any;
    // presetColors = MatColors.presets;
    recordAction = RecordAction;

    constructor(
        public dialogRef: MatDialogRef<MiembroFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private service: MiembrosService,
        private translateService: TranslateService,
        private formBuilder: FormBuilder,
        private validationService: ValidationService
    ) {
        this.miembroModel = data.miembro;
        this.action = data.action;
        this.operators = data.operators;
        this.callback = data.callback;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.dialogTitle = this.miembroModel.msisdn.toString();
        } else {
            this.dialogTitle = "Nuevo Miembro";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            this.miembroModel = new Miembro();
        }

        this.miembroForm = this.createForm();
        this.loadVariables();
    }

    ngOnInit() {}

    isControlValid(form: FormGroup, field: string) {
        return this.validationService.isValidField(form, field);
    }

    getErrorMessage(form: FormGroup, field: string, text: string) {
        return this.validationService.getErrorMessage(form, field, text);
    }

    get variables() {
        return this.miembroForm.get("variables") as FormArray;
    }

    createForm() {
        const form = new FormGroup({
            phoneNumber: new FormControl(this.miembroModel.msisdn, [
                Validators.required,
                Validators.pattern("^[0-9]+$"),
                Validators.minLength(12),
                Validators.maxLength(12),
            ]),
            variables: this.formBuilder.array([]),
        });

        form.controls["phoneNumber"].valueChanges.subscribe(
            (value) => (this.miembroModel.msisdn = value)
        );

        return form;
    }

    private loadVariables() {
        if (
            this.miembroModel.variable &&
            typeof this.miembroModel.variable !== "object"
        ) {
            this.variables.clear();
            let variables = JSON.parse(this.miembroModel.variable);

            Object.entries(variables).forEach(([key, value]) => {
                this.variables.push(
                    this.formBuilder.group({
                        name: [key],
                        value: [value],
                    })
                );
            });
        }
    }

    public addVariable() {
        this.variables.push(this.generateVariablesForm());
    }

    public removeVariable(index: number) {
        this.variables.removeAt(index);
    }

    private generateVariablesForm() {
        return this.formBuilder.group({
            name: [],
            value: [],
        });
    }

    performAction() {
        if (this.miembroForm.invalid) {
            return;
        }

        let numberVariables: Object = {};
        let { variables } = this.miembroForm.value;

        variables.forEach((variable) => {
            numberVariables[variable.name] = variable.value;
        });

        this.miembroModel.variable = numberVariables;

        this.callback(this.miembroModel);
    }
}
